export const TOURNAMENT_DOP_SCORE_TYPES = Object.freeze({
  total: 1,
  sectionsSum: 2,
});

export const TOURNAMENT_DOP_SCORE_MAX = 1000;
export const TOURNAMENT_DOP_SCORE_MIN_SECTION_ITEMS = 2;
export const TOURNAMENT_DOP_SCORE_TOTAL_ITEM_NAME = 'Общее число баллов';
